import { render, staticRenderFns } from "./DecoratedMetaNode.vue?vue&type=template&id=3f87a335&scoped=true&"
import script from "./DecoratedMetaNode.vue?vue&type=script&lang=js&"
export * from "./DecoratedMetaNode.vue?vue&type=script&lang=js&"
import style0 from "./DecoratedMetaNode.vue?vue&type=style&index=0&id=3f87a335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87a335",
  null
  
)

export default component.exports